import { Fragment } from "react";

import Box from "@/components/Box";
import Divider from "@/components/Divider";
import { ExternalTextLink } from "@/components/Links";
import Loading from "@/components/Loading";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import { CMP_PATIENTS_TEST_RESULT_URL, getCmpUrl } from "@/core/urls";
import ChevronComponent from "@/tpo/Chevron";
import Stack from "@/tpo/Stack";
import isProxyEmail from "@/utils/isProxyEmail";
import ButtonV2 from "@/v2/Buttons";

export default function NewResultsReviewList({
  userTests,
  loading,
  emptyMessage = "No new results available",
  buttonSize = "sm"
}) {
  const { organisation } = useOrganisationContext();
  const organisationId = organisation?.hashId;

  if (loading && !userTests?.length) {
    return <Loading />;
  }

  if (!userTests?.length) {
    return (
      <Box fontFamily="gilroyMedium" fontSize={14} lineHeight="20px">
        {emptyMessage}
      </Box>
    );
  }

  return (
    <>
      {userTests.map((userTest, index) => (
        <Fragment key={userTest.id}>
          <Stack gap={15} py={20}>
            <Stack gap={5}>
              <Box fontFamily="gilroyBold" fontSize={16}>
                {userTest.user.fullName}
              </Box>
              {!isProxyEmail(userTest.user.email) ? (
                <Box fontFamily="gilroyMedium" fontSize={14} wordWrap="anywhere">
                  {userTest.user.email}
                </Box>
              ) : null}
            </Stack>
            <Stack gap={5}>
              <Box fontFamily="gilroyBold" fontSize={16}>
                {userTest.testProduct?.name}
              </Box>
              {userTest.orderTestItem?.providerTestId ? (
                <Box fontFamily="gilroyMedium" fontSize={14}>
                  Kit registration: {userTest.orderTestItem.providerTestId}
                </Box>
              ) : null}
            </Stack>
            <ButtonV2
              color="green"
              rightIcon={<ChevronComponent />}
              as={ExternalTextLink}
              underline={false}
              href={getCmpUrl(CMP_PATIENTS_TEST_RESULT_URL, {
                patientId: userTest.user.id,
                userTestId: userTest.id,
                organisationId
              })}
              size={buttonSize}
            >
              review
            </ButtonV2>
          </Stack>
          {index < userTests.length - 1 ? <Divider /> : null}
        </Fragment>
      ))}
    </>
  );
}
